export default __webpack_public_path__ + "static/media/logo.d76def37.svg";